/* unplugin-vue-components disabled */import script from "./IntegralPriceCalendar.vue?vue&type=script&setup=true&lang=js"
export * from "./IntegralPriceCalendar.vue?vue&type=script&setup=true&lang=js"

import "./IntegralPriceCalendar.vue?vue&type=style&index=0&id=6aec872e&lang=scss&scoped=true"

import exportComponent from "/Users/fubeibei/TRAE_workspace/cuiwei_xcxsc/cw/travel-manage/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6aec872e"]])

export default __exports__